export const collectTextures = (input) => {
    const textureKeysAvailable = ['textures'];

    if (!(input instanceof Object)) return [];

    const keys = Object.keys(input);
    const values = Object.values(input);
    let arr = [];

    keys.forEach((key, index) => {
        const value = values[index];

        if (textureKeysAvailable.includes(key)) {
            arr.push({
                textures: value,
                name: input[`${key}Name`]
            });

            return;
        }

        if (value instanceof Object) {
            arr = arr.concat(collectTextures(value));

            return;
        }

        if (value instanceof Array) {
            arr = arr.concat(value.reduce((accumulator, currentValue) => accumulator.concat(collectTextures(currentValue)), []));
        }
    });

    return arr;
};
